// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2fBp6","title":"Info_title__1d8w7","selects":"Info_selects__3-jCr","requiredAsterisk":"Info_requiredAsterisk__1g5jp"};